import React, { Component } from 'react';
import { Row } from "reactstrap";

//Componentes auxiliares:
import DownloadSourceResumeCard from './auxiliars/DownloadSourceResumeCard';

class DownloadSourcesResumePanel extends Component {

    render() {
        return (
            <Row>
                {this.getDownloadSourcesResumeCards()}
            </Row>
        );
    }

    getDownloadSourcesResumeCards = () => {
        let cardsList = [];

        let sortedDownloadSources = [];
        if (this.props.downloadSources.length > 0) {
            sortedDownloadSources = this.props.downloadSources.sort((a, b) => a.id > b.id ? 1 : b.id > a.id ? -1 : 0);
        }

        for (let i = 0; i < sortedDownloadSources.length; i++) {
            cardsList.push(
                <DownloadSourceResumeCard key={"downloadSource." + i}
                    getScratchUrl={this.props.getScratchUrl}
                    downloadSource={sortedDownloadSources[i]}
                    cancelDownloadProcess={this.props.cancelDownloadProcess}
                    retryDownloadProcess={this.props.retryDownloadProcess}
                    executeScratchOnClick={this.props.executeScratchOnClick}
                    getStatusIconClassname={this.props.getStatusIconClassname}
                    getDownloadSourceTitle={this.props.getDownloadSourceTitle}
                    getTimelineDivClassname={this.props.getTimelineDivClassname}
                    getTimelineIconClassname={this.props.getTimelineIconClassname}
                    reloadSourcesMethod={this.props.reloadSourcesMethod} />
            );
        }
        return cardsList;
    }
}

export default DownloadSourcesResumePanel;